module.exports = __webpack_public_path__ + "static/media/Judith.48ae42a4.pdf";